import store from '../store';
import Role from '../utils/Role.util';
import { checkAccess } from '../utils/Acl.util';
// import http from "../utils/Http.util";

export default {
  async isAuthenticatedRoute(to, from, next) {
    if (store.state.auth.loggedIn !== true) return next('/signin');

    if (!store.state.activeBusiness) return next('/businesses');

    return next();
  },
  isUnAuthenticatedRoute(to, from, next) {
    if (!store.state.auth) return next();

    if (store.state.auth.loggedIn === true) return next('/');

    return next();
  },
  isAdmin(to, from, next) {
    if (!Role.isAdmin()) return next('/');

    return next();
  },
  isAuthorizedRoute(to, from, next) {
    // let acl = store.state.acl;
    const hasAccess = true;
    // Check if a user has access
    if (to.meta.requireAuth && to.meta.resources) {
      checkAccess(to.meta.resources);
      // hasAccess = to.meta.resources
      //   .map(resource => acl.hasOwnProperty(resource))
      //   .reduce((a, c) => a && c);
    }

    // If a user does not have access, do not allow the user to access the route
    if (hasAccess) {
      return next();
    }
    return next('/');
  },
};
